"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AgentBio() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="agentbio" className="bg-background py-20 md:py-32 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className={`order-last lg:order-first flex flex-col items-start transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="text-sm font-bold tracking-widest text-muted-foreground uppercase mb-4">
              Meet Your Local Expert
            </span>
            
            <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-6">Anish Patel</h2>
            
            <Separator className="w-16 h-1 bg-[var(--accent-gold)] mb-8 rounded-full" />
            
            <div className="space-y-5 text-lg text-muted-foreground font-sans leading-relaxed">
              <p>Finding the perfect suburban home shouldn't mean compromising your financial future. I specialize in helping families discover incredible properties in Lisle, Aurora, Plainfield, Oswego, and Bolingbrook.</p>
              <p>If you're feeling priced out of Naperville, you're not alone. My mission is to show you that you can still achieve that clean, modern suburban lifestyle without the $700K+ price tag. I leverage local market insights to find hidden gems under $650K that check all your boxes.<br /><br /><br /></p>
            </div>
            
            <Button asChild size="lg" className="mt-10 text-base h-14 px-8 shadow-lg">
              
            </Button>
          </div>

          {}
          <div className={`order-first lg:order-last relative transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="absolute -top-8 -right-8 text-[var(--accent-gold)] opacity-20 z-0 hidden md:block">
              <Quote size={140} strokeWidth={1} />
            </div>
            
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-border/50 bg-muted">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/image_uhpqx7nz.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/image_uhpqx7nz.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/image_uhpqx7nz.jpg-wvc-sizes" alt="Sarah Jenkins - Real Estate Agent" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" loading="lazy" />
              </AspectRatio>
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[var(--accent-gold)]/10 rounded-full blur-2xl z-0"></div>
          </div>

        </div>
      </div>
    </section>;
}